import React from "react";
import { Modal, Button } from "antd";

interface IProps {
    modal: boolean;
    CancelarModal: any;
    AceptarModal: any;
    CancelarArchivo: any;
    TipoDocumento: string;
    NombreArchivo: string;
}

export const ModalAceptar: React.FC<IProps> = (props: IProps) => {
  return (
    <Modal
      title="Subsanar documento"
      style={{ top: 20 }}
      visible={props.modal}
      onCancel={props.CancelarModal}
      closeIcon="X"
      width={window.innerWidth * 0.4}
      footer={[
        <Button key="B_Cancelar_Modal_SubsanarDoc" className="button-gray-ghost" onClick={props.CancelarArchivo}>
          CANCELAR
        </Button>,
        <Button key="B_Aceptar_Modal_SubsanarDoc" className="button-azul-radius" onClick={props.AceptarModal}>
          ACEPTAR
        </Button>,
      ]}
      bodyStyle={{
        padding: 0,
      }}
      maskStyle={{
        backgroundColor: "rgba(31,174,239,0.8)",
        borderRadius: "6px",
      }}
    >
        <div className="row" style={{padding: '30px'}}>
            <div className="col-12
font-family-Montserrat-Regular font-size-14px">¿Estás seguro que desea subsanar? {props.TipoDocumento} con el archivo {props.NombreArchivo}</div>
            {/* <div className=" col-12
font-family-Montserrat-Regular font-size-14px"></div> */}
        </div>
    </Modal>
  );
};
